// React & Nextjs imports
import React from "react";
import Image from "next/image";

// Hooks & Utils
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";

// Components
import ICMWrapper from "@/app/components/icm-wrapper";

// UI Components
// import { IconButton } from "@/stories/icon-button/icon-button";
// import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

// Icons
import Bulb from "@/app/assets/icons/bulb";
import Feat1 from "@/app/assets/images/feat1.png";
import Feat2 from "@/app/assets/images/feat2.png";
// import Feat3 from "@/app/assets/images/feat3.png";
import Feat4 from "@/app/assets/images/feat4.png";
import {
    generalProdctType,
    getRouteWiseProduct,
    productRoute,
    ProductRoute,
} from "@/types/product";
import { toTitleCase } from "@/app/utils/helper";
// import GlobalStocksWhyInvest from "@/app/assets/icons/global-stocks-why-invest";
// import ArrowRightWhite from "@/app/assets/icons/arrow-right-white";

interface WhyUsStocksProps {
    title: string;
    subtitle: string;
    icon: React.ReactNode;
}

interface Benefits {
    title: string;
    subtitle: string;
}

interface Props {
    pageRoute?: ProductRoute;
}

export default function WhyUsStocks({ pageRoute }: Props) {
    const WhyUsStocks: WhyUsStocksProps[] = [
        {
            title: "Access to Innovation",
            subtitle:
                "Participate in sectors and companies not fully<br/>available in Indian markets",
            icon: (
                <div className="mb-7">
                    <Image src={Feat1} height={98} width={97} alt="feat1" />
                </div>
            ),
        },
        {
            title: "Diversify your portfolio",
            subtitle: "Different markets may move differently<br/>across cycles.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat2} height={98} width={97} alt="feat2" />
                </div>
            ),
        },
        {
            title: "Currency Exposure",
            subtitle: "Invest in assets denominated in global<br/>currencies.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat4} height={98} width={97} alt="feat3" />
                </div>
            ),
        },
    ];

    const benefits: Benefits[] = [
        {
            title: "Fractional shares make US markets accessible",
            subtitle: "",
        },
        {
            title: "Investments are protected under US regulatory SIPC",
            subtitle: "",
        },
        {
            title: "Long-term commitment",
            subtitle: "Longer lock-in periods",
        },
    ];

    return (
        <div className="bg-[#334155] bg-[url('https://assets.incredmoney.com/images/webp/broking-hero-top-left.webp')] bg-no-repeat bg-right bg-bottom-[140px] md:bg-[length:48%]">
            <ICMWrapper>
                <div className="flex flex-col items-center py-s15 md:py-s20 md:pb-16">
                    <h2 className="mb-14 text-center text-4xl font-semibold -tracking-[0.56px] text-white md:mb-20 md:text-7xl md:leading-[67.2px] [&_br]:hidden md:[&_br]:block">
                        Why Should Indians Invest<br/>{" "}in US{" "}
                        {pageRoute === productRoute["us-stocks"]
                            ? toTitleCase(getRouteWiseProduct({ route: pageRoute! })) + "s"
                            : pageRoute === productRoute["us-etfs"] && generalProdctType.ETF}
                        ?
                    </h2>
                    <div className="mb-16 flex flex-col items-center justify-between md:justify-center gap-20 md:gap-s22 md:flex-row">
                        {WhyUsStocks.map((item, index) => (
                            <div
                                key={index}
                                className="flex flex-col items-center justify-center align-middle"
                            >
                                {item.icon}
                                <h3 className="mb-2 text-xl font-semibold leading-[26px] text-white">
                                    {item.title}
                                </h3>
                                <p
                                    className="text-center text-sm font-regular leading-[22.4px] tracking-[0.6px] text-[#FFFFFFCC]"
                                    dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                ></p>
                            </div>
                        ))}
                    </div>

                    {/* <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityLight-30 text-white hover:text-black md:max-w-fit"
                        label="Start Investing"
                        onClick={() => {
                            setAnalyticsEvent(
                                `${process.env.ICM_UE_URL || ""}/login`,
                                "US_Listing_Page_Start_Investing",
                            );
                            window.location.href = `${process.env.ICM_UE_URL || ""}/login`;
                        }}
                    /> */}
                </div>
            </ICMWrapper>

            <div className="bg-ue-hero-background">
                <ICMWrapper>
                    <div className="flex flex-wrap items-center justify-between py-s13">
                        <div className="flex items-center md:mb-0">
                            <div className="mr-6 flex h-12 w-12 flex-col items-center justify-center rounded-full bg-gray-700 p-[10px] md:h-[60px] md:w-[60px]">
                                <Bulb className="text-white" />
                            </div>
                            <h4 className="w-3/4 text-wrap text-lg font-semibold leading-[23.4px] text-[#FFFFFFCC] md:w-1/2">
                                How US stock market are different
                            </h4>
                        </div>

                        <div className="mt-10 flex gap-[15px] overflow-x-auto scrollbar-hide md:mt-0 md:gap-20">
                            {benefits.map((item, index) => {
                                return (
                                    <div key={index} className="max-w-[200px]">
                                        <p className="text-sm font-medium leading-[22.4px] tracking-[0.12px] text-neutralOpacityLight-80">
                                            {item.title}
                                        </p>
                                        <p className="text-xs font-medium leading-[22.4px] tracking-[0.12px] text-neutralOpacityLight-70">
                                            {item.subtitle}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                        {/* <IconButton
                            icon={<ArrowRightWhite className="hover:text-black" />}
                            size={ButtonSize.Small}
                            variant={ButtonVariant.SecondaryDefault}
                            className="hidden border-neutralOpacityLight-10 md:flex"
                            onClick={() => {
                                setAnalyticsEvent(
                                    `${process.env.ICM_UE_URL || ""}/login`,
                                    "US_Listing_Page_How_is_Unlisted_Shares_different_section_Arrow",
                                );
                                window.location.href = `${process.env.ICM_UE_URL || ""}/login`;
                            }}
                        /> */}
                    </div>
                </ICMWrapper>
            </div>
        </div>
    );
}
